import React from "react";
import { Loader2, AlertTriangle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TID } from "@/lib/testIds";

/**
 * Confirm bulk deletion of N items. Used by both Clients and Tasks lists.
 */
export default function BulkDeleteConfirmDialog({
  open,
  onOpenChange,
  count,
  entityLabel = "item",
  cascadeNote,
  onConfirm,
  submitting,
}) {
  const plural = count === 1 ? entityLabel : `${entityLabel}s`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-md p-0 gap-0 border-[#E2E8F0]"
        data-testid={TID.bulkConfirmDialog}
      >
        <DialogHeader className="px-6 pt-5 pb-3 border-b border-[#E2E8F0]">
          <DialogTitle className="text-base font-semibold text-[#0F172A] flex items-center gap-2">
            <span className="h-8 w-8 rounded-lg bg-[#FEE2E2] text-[#B91C1C] inline-flex items-center justify-center">
              <AlertTriangle className="h-4 w-4" />
            </span>
            Delete {count} {plural}?
          </DialogTitle>
          <DialogDescription className="text-xs text-[#64748B]">
            This action cannot be undone.
            {cascadeNote ? ` ${cascadeNote}` : ""}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="px-6 py-4 border-t border-[#E2E8F0] bg-[#F8F9FA] rounded-b-lg">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            disabled={submitting}
            className="h-9 px-3 rounded-md border border-[#E2E8F0] bg-white text-sm text-[#334155] hover:bg-[#F1F5F9] disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={submitting}
            data-testid={TID.bulkConfirmCta}
            className="h-9 px-3.5 rounded-md bg-[#DC2626] hover:bg-[#B91C1C] text-white text-sm font-medium disabled:opacity-60 inline-flex items-center gap-2"
          >
            {submitting && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
            Delete {count} {plural}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
